import { AbstractControl, ValidationErrors } from '@angular/forms';

export function apellidoNombreTrabajadorValidator(control: AbstractControl): ValidationErrors | null {
	if (control.value) {
		let apellidoNombre = control.value.replace(/[^a-zA-Z]/g, '');
		if (apellidoNombre.toLowerCase() === 'alta') {
			return { apellidoNombreTrabajadorValidator: true, apellidoNombreTrabajadorValidatorMessage: 'Debe cambiar el apellido y nombre del trabajador.' };
		}
	}
	return null;
}